import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const PHONE = '0536 277 17 09';
const PHONE_HREF = 'tel:+905362771709';

const navLinks = [
  { label: 'Ana Sayfa', href: '/' },
  { label: 'Hakkımızda', href: '/hakkimizda' },
  { label: 'Hizmetler', href: '/hizmetler' },
  { label: 'Referanslar', href: '/referanslar' },
  { label: 'SSS', href: '/sss' },
  { label: 'İletişim', href: '/iletisim' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isLight = scrolled || menuOpen;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${
        isLight ? 'bg-[#FAF7F2] border-b border-[#E8E0D0]' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between" style={{ height: isLight ? '72px' : '88px', transition: 'height 0.3s' }}>
        {/* Logo */}
        <Link to="/" className="cursor-pointer">
          <img
            src={isLight ? '/logo-dark.webp' : '/logo.webp'}
            alt="Alaçatı Tenteci"
            width={155}
            height={58}
            className="h-10 w-auto transition-opacity duration-300"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`text-xs font-semibold tracking-widest uppercase transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === link.href
                  ? 'text-[#D4A853]'
                  : isLight
                  ? 'text-[#111827] hover:text-[#D4A853]'
                  : 'text-white/80 hover:text-white'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Desktop CTA */}
        <a
          href={PHONE_HREF}
          className={`hidden md:flex items-center gap-2 text-xs font-bold tracking-widest uppercase px-5 py-2.5 border-2 transition-all whitespace-nowrap cursor-pointer ${
            isLight
              ? 'border-[#111827] text-[#111827] hover:bg-[#111827] hover:text-white'
              : 'border-white text-white hover:bg-white hover:text-[#111827]'
          }`}
        >
          <i className="ri-phone-line"></i>
          {PHONE}
        </a>

        {/* Mobile Hamburger */}
        <button
          className={`md:hidden w-9 h-9 flex items-center justify-center cursor-pointer transition-colors ${
            isLight ? 'text-[#111827]' : 'text-white'
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menü"
        >
          <i className={`text-2xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#FAF7F2] border-t border-[#E8E0D0] px-4 pb-6">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`flex items-center justify-between py-4 text-xs font-bold tracking-widest uppercase border-b border-[#E8E0D0] cursor-pointer ${
                location.pathname === link.href ? 'text-[#D4A853]' : 'text-[#111827]'
              }`}
            >
              {link.label}
              <i className="ri-arrow-right-line text-[#D4A853]"></i>
            </Link>
          ))}
          <a
            href={PHONE_HREF}
            className="mt-5 flex items-center justify-center gap-2 bg-[#111827] text-white text-xs font-bold tracking-widest uppercase px-6 py-4 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line"></i>
            Hemen Ara — {PHONE}
          </a>
        </div>
      )}
    </header>
  );
}
